import { DialogProps as MuiDialogProps } from '@mui/material/Dialog/Dialog';
import { forwardRef, ReactNode } from 'react';
import MuiDialog from '@mui/material/Dialog';
import { styled } from '@mui/material';

export interface DialogProps extends MuiDialogProps {
  children?: ReactNode;
  color?: 'internal';
  maxWidth?: 'xs' | 'sm' | 'md' | 'xl';
}

const StyledDialog = styled(MuiDialog, {
  name: 'O2Dialog',
  slot: 'root',
  shouldForwardProp: (propName) => propName !== 'color',
})<{ color: DialogProps['color']; maxWidth: DialogProps['maxWidth'] }>(({ theme, color, maxWidth }) => ({
  ...(color && {
    '&& .MuiDialog-paper': {
      backgroundColor: theme.palette.background[color],
    },
  }),
  ...(maxWidth === 'xs' && {
    '& .MuiDialog-paper': {
      maxWidth: 280,
    },
    '& .MuiDialogActions-root > *': {
      flex: '0 0 100%',
    },
  }),
  ...(maxWidth === 'sm' && {
    '& .MuiDialog-paper': {
      maxWidth: 448,
    },
  }),
  ...(maxWidth === 'md' && {
    '& .MuiDialog-paper': {
      maxWidth: 848,
    },
  }),
  ...(maxWidth === 'xl' && {
    '& .MuiDialog-paper': {
      maxWidth: '100%',
    },
  }),
}));

const Dialog = forwardRef<HTMLDivElement, DialogProps>((props, ref) => {
  const { children, color, maxWidth, ...other } = props;

  return (
    <StyledDialog ref={ref} color={color} maxWidth={maxWidth} {...other}>
      {children}
    </StyledDialog>
  );
});

Dialog.displayName = 'Dialog';

export default Dialog;
